/**
 * Utility functions for handling @mentions in community discussions
 */

/**
 * Extract all @mentions from text content
 * @param content - The text content to scan for mentions
 * @returns Array of mentioned names (without the @ symbol)
 */
export function extractMentions(content: string): string[] {
  // Match @word patterns, allowing letters, numbers, and some special characters
  const mentionRegex = /@(\w+)/g;
  const mentions: string[] = [];
  let match;
  
  while ((match = mentionRegex.exec(content)) !== null) {
    const mentionName = match[1]; // Extract name without @
    // Avoid duplicates
    if (!mentions.includes(mentionName.toLowerCase())) {
      mentions.push(mentionName.toLowerCase());
    }
  }
  
  return mentions;
}

/**
 * Check if content contains any @mentions
 * @param content - The text content to check
 * @returns True if content contains mentions
 */
export function hasMentions(content: string): boolean {
  return /@\w+/.test(content);
}

/**
 * Remove @mentions from text content
 * @param content - The text content to clean
 * @returns Content with mentions removed
 */
export function removeMentions(content: string): string {
  return content.replace(/@\w+/g, '').trim();
}

/**
 * Replace @mentions with formatted mentions
 * @param content - The text content
 * @param formatter - Function to format each mention
 * @returns Content with formatted mentions
 */
export function formatMentions(
  content: string, 
  formatter: (mention: string) => string
): string {
  return content.replace(/@(\w+)/g, (match, name) => formatter(name));
} 